<div class="switch-component" [class]="classes()">
	@if (label()) {
		<label [for]="switchId()">{{ label() }}</label>
	}
	<input
		type="checkbox"
		class="toggle"
		[id]="switchId()"
		[class]="color()"
		[checked]="checked()"
		(change)="onChange($event)"
	/>
</div>
